// extracted by mini-css-extract-plugin
export default {"form":"AutorunForm_form__4gvaK","disableForm":"AutorunForm_disableForm__pL-lv"};